import { render, staticRenderFns } from "./invite-person.vue?vue&type=template&id=54f40e6a&scoped=true&"
import script from "./invite-person.vue?vue&type=script&lang=js&"
export * from "./invite-person.vue?vue&type=script&lang=js&"
import style0 from "./invite-person.vue?vue&type=style&index=0&id=54f40e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f40e6a",
  null
  
)

export default component.exports